import React, { useEffect, useState } from "react";
import "./listAssociations.scss";

import NoOneElement from "../../components/noOneElement/NoOneElement";
import HeaderBar from "../../components/headerBar/HeaderBar";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import AssociationInfoBox from "../../components/associationInfoBox/AssociationInfoBox";
import SearchInput from "../../components/searchInput/SearchInput";

import { useLocation } from "react-router-dom";
import { t } from "i18next";
import { getListAssociationsWS } from "./api/listAssociationAPI";
import { isEmpty } from "../../utils/validation";
import { Col, Row } from "react-bootstrap";

const ListAssociations = () => {
  const [filteredAssociations, setFilteredAssociations] = useState([]);
  const [listAssociations, setListAssociations] = useState([]);

  const [type, setType] = useState("");
  const [search, setSearch] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    const typeFromURL = queryParams.get("type");
    setType(typeFromURL); // Imposta il valore di type nello stato

    getListAssociationsWS({
      favourite: typeFromURL === "follow",
      volunteer: typeFromURL === "volunteer",
    })
      .then((res) => {
        setListAssociations(res);
        setFilteredAssociations(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [location.search]);

  const searchFunction = () => {
    if (!isEmpty(search)) {
      setFilteredAssociations(
        listAssociations.filter((association) => {
          const name = association.name?.toLowerCase() || "";
          const address = association.address?.toLowerCase() || "";
          const date = association.date_of_foundation?.toLowerCase?.() || "";

          return (
            name.includes(search.toLowerCase()) ||
            address.includes(search.toLowerCase()) ||
            date.includes(search.toLowerCase())
          );
        })
      );
    } else {
      setFilteredAssociations(listAssociations);
    }
  };

  console.log(listAssociations);

  return (
    <>
      <HeaderBar
        back={true}
        title={
          type === "follow"
            ? t("list_associations.follow_associations")
            : t("list_associations.all_associations")
        }
      />
      <div className="list-association-container container-responsive">
        <SearchInput
          search={search}
          setSearch={setSearch}
          searchFunction={searchFunction}
        />
        {!isEmpty(filteredAssociations) ? (
          <Row
            sm={1}
            md={1}
            lg={2}
            xl={2}
            xxl={2}
            className="g-2 d-flex justify-content-center mt-2"
          >
            {filteredAssociations.map((item, index) => (
              <Col key={index} sm={12} md={12} lg={6} xl={6} xxl={6}>
                <AssociationInfoBox
                  id={item.id}
                  name={item.name}
                  address={item.address}
                  image={
                    item.image
                      ? "data:" + item.image_type + ";base64," + item.image
                      : "/no_img.png"
                  }
                />
              </Col>
            ))}
          </Row>
        ) : (
          <div className="list-association-content">
            <NoOneElement
              title={t("common.oops")}
              subtitle={t("my_associations.empty")}
              image="/empty_association.png"
              explore={true}
            />
          </div>
        )}
        <VoidSpace />
      </div>
    </>
  );
};

export default ListAssociations;
